export const base = (
    eventId = ':event'
) => `events/${eventId}/artists/offers`;
